/* eslint-disable */
/*
 *
 * describe 定义各常量的值
 * @author mingchenxu
 * @date 2018/4/25 19:36
 * @param  * @param null
 * @return
 */

export default{
  install(Vue, options) {
    Vue.prototype.getData = function (constName) {
      return eval(constName)
    }
  }
}
// *********************************   定义各常量的值   ****************************** //
//                  初始化方法： 在组件中初始化时，定义变量接受全局VUE                 //
//                  方法中使用： this.别名.getData('常量名')                           //
// *********************************************************************************** //

/* ************************************ 病例各状态 start ****************************** */
// 退回病例
const STATE_0NN = -1
// 无效
const STATE_0LE = 0
// 切图生成中
const STATE_SLICING = 1
// 失败，异常
const STATE_FAIL = 2
// 未筛查
const STATE_0WS = 9
// 已预诊
const STATE_0BC = 10
// 初诊中
const STATE_1FG = 11
// 已初诊
const STATE_1FC = 12
// 复诊中
const STATE_2RG = 21
// 等待继续复诊
const STATE_2RN = 22
// 等待重新复诊
// const STATE_2RR = 23
// 等待下个医院复诊
const STATE_2RH = 26
// 已复诊
const STATE_2RA = 25
// 已复诊确认最终报告
// const STATE_2RC = 24
// 已初诊待会诊
const STATE_1FC_1GC = 30
// 已复诊待会诊
const STATE_2RC_1GC = 31
// 会诊中
const STATE_3GG = 32
// 诊断结束
const STATE_5DC = 50
// 最后一位复诊医生重新诊断中
const STATE_5RG = 51
// 诊断结束并打印报告
const STATE_6DC = 60
// 切图已删除
const STATE_PICTURE = 70
/* ************************************ 病例各状态 end ****************************** */

/* ************************************ 操作的URL地址 start ****************************** */
// 是否显示二维码操作
const IS_SHOW_SCAN_CODE_URL = 'casemanager/isShowScanQRCode'
// 获取字典表相关信息
const GET_DIC_INFO_URL = 'casemanager/getDicInfo'
// 获取病例列表URL
const GET_CASE_LIST_URL = 'casemanager/getcaselist'
// 获取样本玻片信息
const GET_SAMPLE_SLIDE_INFO_URL = 'casemanager/getsampleslideinfo'
// 根据玻片id删除玻片信息
const DEL_SLIDE_BY_SLIDEID_URL = 'casemanager/delslide'
// 打印玻片二维码
const PRINT_SLIDE_QRCODE_URL = 'casemanager/printqrcode'
// 获取不同状态的病例数URL
const GET_DIF_STATE_SLIDE_NUM_URL = 'casemanager/countCaseStates'
// 获取病例详情信息
const GET_CASE_DETAIL_URL = 'casemanager/getcasedetail'
// 获取样本详情信息
const GET_SAMPLE_DETAIL_URL = 'casemanager/getsampledetail'
// 获取玻片详情信息
const GET_SLIDE_DETAIL_URL = 'casemanager/getslidedetail'
// 修改病人详情信息
const GET_EDIT_CASE_PATIENT_URL = 'casemanager/editcasepatient'
// 修改病例样本信息
const GET_EDIT_CASE_SAMPLE_URL = 'casemanager/editcasesample'
// 修改样本玻片信息
const GET_EDIT_SAMPLE_SLIDE_URL = 'casemanager/editsampleslide'
// 新增病例的样本信息
const GET_ADD_CASE_SAMPLE_URL = 'casemanager/addcasesample'
// 新增样本的玻片信息
const GET_ADD_SAMPLE_SLIDE_URL = 'casemanager/addsampleslide'
// 添加病例信息
const ADD_NEW_CASE_URL = 'casemanager/addnewcase'
// 获取医院列表
const GET_HOSPITAL_LIST_URL = 'casemanager/getHospitalList'
// 获取取材图像信息集合
const GET_MATERIALS_INFO_LIST_URL = 'casemanager/getMaterialsInfoList'
// 删除取材图像信息
const DELETE_MATERIALS_INFO_URL = 'casemanager/deleteMaterialsInfo'
// 添加取材图像信息
const ADD_MATERIALS_INFO_LIST_URL = 'casemanager/addMaterialsInfo'
// 删除病例信息
const DEL_CASE_DETAIL = 'casemanager/delCaseDetail'
// 获取病例报告
const GET_CASE_REPORT_URL = 'casemanager/getCaseReport'
// 根据caseId 获取诊断信息
const GET_REPORT_DIAGNOSE_RESULT_URL = 'casemanager/getReportDiagnoseResult'
// 保存诊断信息
const SAVE_DIAGNOSE_RESULT_URL = 'casemanager/saveDiagnoseResult'
// 查看诊断报告
const SHOW_CASE_REPORT_URL = 'casemanager/showCaseReport'
// 下载pdf报告
const UPLOAD_REPORT_URL = 'casemanager/uploadReport'
// 获取互联网病例信息
const GET_NET_PATIENT_URL = 'casemanager/getNetPatient'
// 获取用户列表
const GET_USER_NAME_LIST_URL = 'casemanager/getUserNameList'
// 用户登录
const LOGIN_URL = 'casemanager/login'
// 用户退出登录
const LOGIN_OUT_URL = 'casemanager/addLoginOutLog'
// 获取是否开启登录页面
const GET_LOGIN_STATUS_URL = 'casemanager/getLoginStatus'
// 根据订单号查询检测人信息
const GET_EPS_PATIENT_URL = 'casemanager/getEpsPatient'
const IMPORT_CASE = '/casemanager/importCase'
// 查询所有未扫描的玻片信息
const GET_NOSCAN_LAYERLIST_URL = 'casemanager/getNoScanLayerList'
// 查询所有分析失败的玻片信息
const GET_ERROR_LAYERLIST_URL = 'casemanager/getScanErrorLayerList'
// 获取病例检测状态
const GET_REPORTSTATE_URL = 'casemanager/getReportState'
// 提交申请单
const GET_APPLICATIONFORM_URL = 'casemanager/getApplicationForm'
// 获取检测报告
const GET_NODOWREPORT_URL = 'casemanager/getNoDowReport'
// 修改病例样本状态
const UPDATE_CASE_STATE_URL = 'casemanager/updateCaseState'
/* ************************************ 操作的URL地址 end ****************************** */






// WEBPACK FOOTER //
// ./src/utils/CaseManagerConst.js